
export const storeProducts = [
  {
    id: 1,
    title: "Rich dad, Poor dad",
    img: "img/rich dad.png",
    price: 10,
    author: "Robert Kiyosaki",
    about:
    "'Well, Son…\' he began slowly. \'If you want to be rich, you have to learn to make money.\' \'How do I make money?\' I asked. \'Well, use your head, Son,\' he said, smiling. Even then I knew that really meant, \'That is all I am going to tell you,\' or \'I do not know the answer, so do not embarrass me.'",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Money Master the Game",
    img: "img/money-master-the-game.png",
    price: 15,
    author: "Tony Robbins",
    about:
    "Money. Few words have the power to provoke such extreme human emotions. A lot of us refuse to even talk about money! Like religion, sex, or politics, the topic is taboo at the dinner table and often off-limits in the workplace. We might discuss wealth in polite company, but money is explicit. It’s raw. It’s garish. It’s intensely personal and highly charged. It can make people feel guilty when they have it—or ashamed when they don’t. But what does it really mean?",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "How to Win Friends and Influence People",
    img: "img/how-to-win-friends.png",
    price: 6,
    author: "Dale Carnegie",
    about:
    "If you wish to get the most out of this book, there is one indispensable requirement, one essential infinitely more important than any rule or technique. Unless you have this one fundamental requisite, a thousand rules on how to study will avail little. And if you do have this cardinal endowment, then you can achieve wonders without reading any suggestions for getting the most out of a book. What is this magic requirement? Just this: a deep, driving desire to learn, a vigorous determination to increase your ability to deal with people",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "The 4-Hour Work Week",
    img: "img/4-hour-work-week.png",
    price: 12,
    author: "Timothy Ferris",
    about:
      "If you've picked up this book, chances are that you don't want to sit behind a desk until you are 62. Whether your dream is escaping the rat race, real-life fantasy travel, long-term wandering, setting world records, or simply a dramatic career change, this book will give you all the tools you need to make it a reality in the here-and now instead of in the often elusive 'retirement.' There is a way to get the rewards for a life of hard work without waiting until the end.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "You are a badass",
    img: "img/you-are-a-badass.png",
    price: 8,
    author: "Jen Sincero",
    about:
    "This is about getting mighty clear about what makes you happy and what makes you feel the most alive, and then creating it instead of pretending you can’t have it. Or that you don’t deserve it. Or that you’re a greedy egomaniacal fathead for wanting more than you already have. Or listening to what Dad and Aunt Mary think you should be doing. It’s about having the cojones to show up as the brightest, happiest, badassiest version of yourself, whatever that looks like to you. The good news is that in order to do this, all you need to do is make one simple shift: You need to go from wanting to change your life to deciding to change your life"    
    ,inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "The Richest Man in Babylon",
    img: "img/the-richest-man-in-babylon.png",
    price: 15,
    author: "George S. Clasen",
    about:
    "What can a book written in the 1920s tell modern investors about their finances? A whole lot if it's George Clason's delightful set of parables that ex - plain the basics of money. This is a great gift for a graduate or anyone who seems baffled by the world of finance and a wonderful, refreshing read for even the most experienced investor. —Los Angeles Times",    
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Outliers",
    img: "img/outliers.png",
    price: 11,
    author: "Malcolm Gladwell",
    about:
    " There is a story that is usually told about extremely successful people , a story that focuses on intelligence and ambition. In Outliers Malcolm Gladwell argues that the true story of success is very different, and that if we want to understand how some peopl e thrive, we should spend more time looking around them — at such things as their family, their birthplace, or even their birth date. Th e story of success is more complex — and  a lot more interesting — than it initially appears. Outliers explains what the Beatles and Bill Gate s have in common , the extraordinary success of Asians at math, the hidden advantages of star athletes, why all top New York lawyers have the same résumé , and the reason you've never heard of the world's smartest man — all in terms of generation, family, culture, and class",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Principles",
    img: "img/Principles.png",
    price: 9,
    author: "Ray Dalio",
    about:
    "Look to the patterns of those things that affect you in order to understand the cause-effect relationships that drive them and to learn principles for dealing with them effectively.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 9,
    title: "Think and Grow Rich",
    img: "img/think-and-grow-rich.png",
    price: 11,
    author: "Napolean Hill",
    about:
    "Despite the book’s title, this book is not about how to increase your income and become rich. The author’s philosophy can help just about anyone succeed in their professional life, achieve their aspirations, and attract success in their life, but it’s definitely a must-read for investors and entrepreneurs.",    
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 10,
    title: "The Little Book of Common Sense Investing",
    img: "img/The_Little_Book_of_Common_Sense_Investing.png",
    price: 14,
    author: "John C. Bogle",
    about:
    "SUCCESSFUL INVESTING IS ALL about common sense. As the Oracle has said, it is simple, but it is not easy. Simple arithmetic suggests, and history confirms, that the winning strategy is to own all of the nation’s publicly held businesses at very low cost. By doing so you are guaranteed to capture almost the entire return that they generate in the form of dividends and earnings growth.",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailBook = {
  id: 1,
  title: "Rich dad, Poor dad",
  img: "img/rich dad.png",
  price: 10,
  author: "Robert Kiyosaki",
  about:
  "'Well, Son…\' he began slowly. \'If you want to be rich, you have to learn to make money.\' \'How do I make money?\' I asked. \'Well, use your head, Son,\' he said, smiling. Even then I knew that really meant, \'That is all I am going to tell you,\' or \'I do not know the answer, so do not embarrass me.'",
  inCart: false,
  count: 0,
  total: 0
};
